<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item item-row">
                <span>样式</span>
                <div class="select-box">
                    <el-select v-model="dataList.icon" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in iconOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <span>显示分值说明</span>
                <el-switch v-model="dataList.showScoreExplain" class="ml-2" />
            </div>
            <div class="setting-content-item" v-show="dataList.showScoreExplain">
                <span>分值说明</span>
                <div class="item-row">
                    <span>0分</span>
                    <div class="select-box">
                        <el-input class="score-box" v-model="dataList.miniScoreExplain"></el-input>
                    </div>
                </div>
                <div class="item-row">
                    <span>10分</span>
                    <div class="select-box">
                        <el-input class="score-box" v-model="dataList.maxScoreExplain"></el-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-nps-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
const iconOptions = [
    { label: "圆型数字", value: "1" },
    { label: "方型数字", value: "2" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        flex-shrink: 0;
    }
    span.score {
        font-size: 14px;
        font-weight: 400;
        color: rgba(183, 186, 191, 1);
    }
    .select-box {
        width: 100%;
        margin-left: 6px;
    }
}

:deep(.el-select--large, .score-box.el-input) {
    width: 100%;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
